import size from 'lodash/size';

import type { QuoteAppData } from '../../types/app_data';
import type { Step } from '../types/step';

export const QuotesStep: Step = {
  id: 'quotes',
  pathname: '/quotes',
  canShow: (appData: QuoteAppData) => {
    return size(appData.bundledQuotes) > 0;
  },
  hasData: () => true,
  hasOwnData: () => true,
};
